export default __webpack_public_path__ + "static/aboutUs_1@2x-d6532c9a505ae8eb20e40b456924e036.jpg";